import { Route } from "react-router-dom";
import Denied from "../pages/Denied";
import NotFound from "../pages/404";

export const errorsRoutes = (
    <>
        <Route path="/denied" element={<Denied />} key="denied" />
        <Route path="*" element={<NotFound />} key="not_found" />
    </>
);
